import { render, staticRenderFns } from "./videohub.vue?vue&type=template&id=560e261a&scoped=true"
import script from "./videohub.vue?vue&type=script&lang=js"
export * from "./videohub.vue?vue&type=script&lang=js"
import style0 from "./videohub.vue?vue&type=style&index=0&id=560e261a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e261a",
  null
  
)

export default component.exports